import React from 'react'
import Header, { listImage } from '../../components/header/header'
import Layout from '../../core/layout/layout'
import HeaderOptions from '../../components/header-options/header-options'
import styled from 'styled-components'
import SectionTC from '../../components/section-tc/section-tc'
import { device } from '../../config/theme/breakpoints'
import FeatureItem from '../landing/components/feature-item/feature-item'
import { listFeature, listOfferItem } from '../landing/data'
import CustomSlider from '../../components/custom-slider/custom-slider'
import PaymentMethods from '../landing/components/payment-methods/payment-methods'
import Slider from "react-slick";
import OfferItem from '../landing/components/offer-item/offer-item'
import TitleSection from '../../components/title-section/title-section'
import ButtonTC from '../../components/button-tc/button-tc'
import InputTC from '../../components/input-tc/input-tc'
import { EmailOutline } from '@styled-icons/evaicons-outline'
import { PhoneCall } from '@styled-icons/feather'
import { CreditCard } from '@styled-icons/feather'
import { CheckCircle } from '@styled-icons/bootstrap'
import ItemContact from './components/item-contact/item-contact'
import { User } from '@styled-icons/boxicons-regular'
import { SuitcaseRolling } from '@styled-icons/fa-solid'
import { Calendar } from '@styled-icons/feather'
import { CloseCircle } from '@styled-icons/ionicons-outline/CloseCircle'
import { Whatsapp } from '@styled-icons/boxicons-logos'
import TextareaTC from '../../components/textarea-tc/textarea-tc'
import { Circle } from '@styled-icons/bootstrap'
import { NavLink } from 'react-router-dom'

export const listItem = [
    {
        id: 1,
        icon: <User />,
        name: 'Pasajero frecuente',
        to: '/preguntas-frecuentes'
    },
    {
        id: 2,
        icon: <SuitcaseRolling />,
        name: 'Restricciones de tarifa',
        to: '/preguntas-frecuentes'
    },
    {
        id: 3,
        icon: <Calendar />,
        name: 'Centro de ayuda',
        to: '/preguntas-frecuentes'
    },
    {
        id: 4,
        icon: <CloseCircle />,
        name: 'Términos y condiciones',
        to: '/preguntas-frecuentes'
    },
    {
        id: 5,
        icon: <CloseCircle />,
        name: 'Libro de reclamaciones',
        to: '/preguntas-frecuentes'
    },
    {
        id: 6,
        icon: <CloseCircle />,
        name: 'Protección de datos',
        to: '/preguntas-frecuentes'
    },
    {
        id: 7,
        icon: <CloseCircle />,
        name: 'Trabaja con nosotros',
        to: '/preguntas-frecuentes'
    },
]

const BodyHeaderContainer = styled.div`
  color: white;
  text-align: center;
  width: 100%;
  padding: 80px 0 50px;

  > div span{
    font-size: 12px;
  }

  @media ${device.tablet}{
    padding: 120px 0 50px;
  }
`
const PreTitle = styled.h3`
  font-style: italic;
  margin-bottom: 10px;
  font-weight: lighter;
  text-transform: uppercase;
  margin: 0;
  margin-top: 50px;
`
const Title = styled.h1`
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 40px;
  text-transform: uppercase;
  position: relative;
  width: fit-content;
  margin: auto;
  padding-bottom: 5px;
  margin-bottom: 40px;
`
const TitleBar = styled.div`
    width: 30px;
    height: 7px;
    background: ${p => p.theme.palette.secondary.main};
    position: absolute;
    right: 0;
    bottom: 0;
    border-radius: 6px 0 15px 6px;
    transform: skew(-30deg);
`

const ContainerContact = styled.div`
  display: flex;
  width: 100%;
  gap: 15px;
  flex-wrap: wrap;
  justify-content: space-around;

  > div{
    width: 100%;

    @media ${device.tablet}{
      width: 46%;
    }
  }
`
const ContainerLeft = styled.div`
  box-shadow: 0px 2px 12px 0px #d9d9d9;
  background: white;
  padding: 40px;
  border-radius: 10px;
`

const ContainerRight = styled.div`
  background: white;
  box-shadow: 0px 2px 12px 0px #d9d9d9;
  padding: 40px;
  border-radius: 10px;
`

const ContainerWhatsapp = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  text-decoration: none;
  cursor: pointer;

  > svg {
    color: ${p => p.theme.palette.text.gray};
    max-width: 80px;
  }
`

const InputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  > div {
    width: 100%;

    @media ${device.tablet}{
      width: 50%;
    }
  }
`
const ContainerTerms = styled.div`
  display: flex;
  margin-top: 20px;
  cursor: pointer;

  > svg{
    color: red;
    max-width: 20px;
    margin-right: 5px;
  }

  > p{
    margin: 0;
    font-size: 12px;
    align-self: center;
    color: ${p => p.theme.palette.text.gray}
  }
`
const FeatureCustomClass = `
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  gap: 15px;
  padding-top: 5px;
  padding-bottom: 5px;

  @media ${device.mobileL}{
    justify-content: space-around;
  }
`

const CustomButton = `
  border-radius: 20px 4px 20px 4px;
  margin-top: 40px;
  padding: 8px 15px;

  > div div {
    font-size: 20px;
  }
`

const CustomTitle = `
  > h4 {
    font-size: 20px
  }

  > div h2 {
    font-size: 30px;
  }
`

const ContactUs: React.FunctionComponent = () => {
  const [statusTerms, setStatusTerms] = React.useState(false)
  const sliderOfferRef = React.useRef<Slider>(null);
  const handleStatusTerms = () => setStatusTerms(!statusTerms)

  return (
    <Layout>
        <Header images={listImage}>
          <BodyHeaderContainer>
            <SectionTC>
              <PreTitle>Estamos aquí</PreTitle>
              <Title>
                Para atenderte
                <TitleBar />
              </Title>
              <span>Coméntanos en que podemos ayudarte</span>
            </SectionTC>
          </BodyHeaderContainer>
        </Header>
        <HeaderOptions>
          <SectionTC className={FeatureCustomClass}>
            {listFeature.map(feature => (
              <FeatureItem
                key={feature.id}
                icon={feature.icon}
                title={feature.title}
                subTitle={feature.subTitle}
                description={feature.description}
              />
            ))}
          </SectionTC>
        </HeaderOptions>
        <SectionTC>
          <TitleSection preTitle='Ayuda' title='Contáctanos'/>
          <p>Comentanos en que podemos ayudarte, tambien nos puedes contactar a través de nuestro fonobus, llamándonos al <b>311-5050</b> en Lima metropolitana y desde provincias al <b>0801-11111</b>.</p>
          <ContainerContact>
            <ContainerLeft>
                <InputTC type='text' icon={<User />} textHolder='Nombre y Apellidos'/>
              <InputWrapper>
                <InputTC type='text' icon={<EmailOutline />} textHolder='Correo electrónico'/>
                <InputTC type='text' icon={<PhoneCall />} textHolder='Nro. Teléfono'/>
              </InputWrapper>
              <InputTC type='text' icon={<CreditCard />} textHolder='DNI'/>
              <TextareaTC textHolder='Escribe aquí tu mensaje'/>
              <ContainerTerms onClick={handleStatusTerms}>
                {statusTerms ? <CheckCircle /> : <Circle />}
                <p>Debes aceptar nuestros términos y condiciones</p>
              </ContainerTerms>
              <ButtonTC text='Enviar mensaje' className={CustomButton}/>
            </ContainerLeft>
            <ContainerRight>
              {listItem.map(item => (
                <ItemContact
                  key={item.id}
                  icon={item.icon}
                  name={item.name}
                  to={item.to}
                />
              ))}
              <ContainerWhatsapp href='https://wa.link/cn2ito' target='_blank'>
                <Whatsapp />
                <TitleSection preTitle='WhatsApp' title='972013941' className={CustomTitle}/>
              </ContainerWhatsapp>
            </ContainerRight>
          </ContainerContact>
        </SectionTC>
        <SectionTC>
          <PaymentMethods />
        </SectionTC>
        <CustomSlider
          sliderRef={sliderOfferRef}
          preTitle='Principales destinos'
          title='Y promociones'
          size={listOfferItem.length}
          withIconRight
        >
          {listOfferItem.map(offer => (
            <div key={offer.id}>
              <OfferItem
                  tour={offer.tour}
                  price={offer.price}
                  title={offer.title}
                  subTitle={offer.subTitle}
                  image={offer.image}
                />
            </div>
          ))}
        </CustomSlider>
    </Layout>
  )
}

export default ContactUs